import Rule from '../rules/rule';
import ReplaceRule from '../rules/replace.rule';
import DefaultRule from '../rules/default.rule';
import TrimRule from '../rules/trim.rule';
import StripSpacesRule from '../rules/stripSpaces.rule';
import ListRule from '../rules/list.rule';
import UppercaseRule from '../rules/uppercase.rule';
import LowercaseRule from '../rules/lowercase.rule';
import PrefixRule from '../rules/prefix.rule';
import SuffixRule from '../rules/suffix.rule';
import ExcludeRule from '../rules/exclude.rule';
import DateRule from '../rules/date.rule';
import CalcRule from '../rules/calc.rule';
import RoundRule from '../rules/round.rule';

export default function createRule(text, attribute, active) {
  if (/^\s?replace/i.test(text)) {
    return new ReplaceRule(text, attribute, active);
  } else if (/^\s?default/i.test(text)) {
    return new DefaultRule(text, attribute, active);
  } else if (/^\s?trim/i.test(text)) {
    return new TrimRule(text, attribute, active);
  } else if (/^\s?strip spaces/i.test(text)) {
    return new StripSpacesRule(text, attribute, active);
  } else if (/^\s?list/i.test(text)) {
    return new ListRule(text, attribute, active);
  } else if (/^\s?uppercase/i.test(text)) {
    return new UppercaseRule(text, attribute, active);
  } else if (/^\s?lowercase/i.test(text)) {
    return new LowercaseRule(text, attribute, active);
  } else if (/^\s?prefix/i.test(text)) {
    return new PrefixRule(text, attribute, active);
  } else if (/^\s?suffix/i.test(text, attribute, active)) {
    return new SuffixRule(text, attribute, active);
  } else if (/^\s?exclude/i.test(text, attribute, active)) {
    return new ExcludeRule(text, attribute, active);
  } else if (/^\s?date/i.test(text)) {
    return new DateRule(text, attribute, active);
  } else if (/^\s?calc/i.test(text)) {
    return new CalcRule(text, attribute, active);
  } else if (/^\s?round/i.test(text)) {
    return new RoundRule(text, attribute, active);
  }

  return new Rule(text, attribute, active);
}
